import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'lvmSalesHistory';

export const fetchLvmSalesHistory = (periodType, retailerId) => {
  const url = DepsService.rest.widgets.lvmSalesHistory.url;
  const queryParams = { periodType };
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchLvmSales= (retailerId) => {
  const url = DepsService.rest.widgets.lvmSales.url;
  const queryParams = { };
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadLvmSalesHistoryReport = (extension, periodType, retailerId) => {
  const url = DepsService.rest.widgets.lvmSalesHistory.url;
  const queryParams = { periodType };
  const urlParams = { retailerId };
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/lvm-sales-history.api.js